export const Cabinet = {
  IncomingDocuments: 'I',
  DocumentToStoreDocumentTypeDescription: 'To Index',
  MyIncomingDocumentsReferenceKey: 'cref5',
  DocumentDateReference: {
    FieldKey: 'DocumentDate',
    key: 'documentDate'
  }
};
